import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';

import { SignupComponent } from './signup/signup.component';
// import { AllworkspaceComponent } from './allworkspace/allworkspace.component';
// import { WorkspaceComponent } from './workspace/workspace.component';
// import { NewinvoiceComponent } from './newinvoice/newinvoice.component';
import { AuthGuardService} from 'src/service/auth-guard.service';
import { SetpasswordComponent} from './setpassword/setpassword.component';
import { ForgotpasswordComponent} from './forgotpassword/forgotpassword.component';
import { SignOnComponent } from './sign-on/sign-on.component';

const routes: Routes = [
  {path: 'login', component: LoginComponent},
  {path: 'signon/:token', component: SignOnComponent},
  {path: 'setpassword/:token', component: SetpasswordComponent},  
  {path: 'forgotpassword/:token', component: ForgotpasswordComponent},    
  {path: 'signup', component: SignupComponent},
  {path: 'superadmin', 
  loadChildren:()=>import('./super-admin/super-admin.module')
    .then(m=>m.SuperAdminModule)
  },  
  {path: 'admin', 
    loadChildren:()=>import('./admin/admin.module')
      .then(m=>m.AdminModule),
      canActivate: [AuthGuardService]
  },  
  {path: 'reviewer', 
    loadChildren:()=>import('./reviewer/reviewer.module')
      .then(m=>m.ReviewerModule),
      canActivate: [AuthGuardService]
  },  
  {path: 'customer', 
    loadChildren:()=>import('./customer/customer.module')
      .then(m=>m.CustomerModule),
      canActivate: [AuthGuardService]
  },  
  { path: '',   redirectTo: 'login', pathMatch: 'full' },
  { path: '**', redirectTo: 'login', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
